import React, { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";

const links = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Services", id: "services" },
  { label: "Why Choose Me", id: "why" },
  { label: "Free Guide", id: "guide" },
  { label: "Testimonials", id: "testimonials" },
  { label: "Contact", id: "contact" },
];

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-navigation"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#1A1918]/85 border-b border-[#C89D54]/15 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => handleClick("home")}
          className="flex items-baseline gap-2 group"
        >
          <span className="font-serif-display text-2xl md:text-3xl text-[#F4F0EB] tracking-tight">
            M <span className="text-[#C89D54]">Skierniewski</span>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => handleClick(l.id)}
              className="font-sans-body text-sm text-[#A6A098] hover:text-[#F4F0EB] transition-colors duration-300 tracking-wide"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <a
          data-testid="nav-phone-cta"
          href="tel:+447810620113"
          className="hidden lg:inline-flex items-center gap-2 text-sm font-semibold text-[#C89D54] hover:text-[#DDB46F] transition-colors border border-[#C89D54]/40 hover:border-[#C89D54] px-4 py-2"
        >
          <Phone size={14} strokeWidth={2.2} /> 07810 620113
        </a>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-[#F4F0EB] p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle navigation"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden border-t border-[#C89D54]/15 bg-[#1A1918]/98 backdrop-blur-xl"
        >
          <nav className="flex flex-col px-6 py-6 gap-5">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`mobile-nav-${l.id}`}
                onClick={() => handleClick(l.id)}
                className="text-left font-sans-body text-base text-[#A6A098] hover:text-[#C89D54] transition-colors"
              >
                {l.label}
              </button>
            ))}
            <a
              href="tel:+447810620113"
              className="mt-2 inline-flex items-center gap-2 text-sm font-semibold text-[#C89D54]"
            >
              <Phone size={14} /> 07810 620113
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Navigation;
